/**
 * admin 側でも使う static file 群を app/assets 以下にコピーする
 */
'use strict';

// SVG
require('file-loader?name=[name].[ext]!common/ui/svg/balus-icon.svg');
require('file-loader?name=[name].[ext]!common/ui/svg/balus-icon-white.svg');

// CSS
require('file-loader?name=[name].[ext]!bootstrap/dist/css/bootstrap.min.css');
require('file-loader?name=[name].[ext]!common/ui/css/bootstrap-material-design/bootstrap-material-design.min.css');
require('file-loader?name=[name].[ext]!common/ui/css/bootstrap-material-design/ripples.min.css');
require('file-loader?name=[name].[ext]!dropzone/dist/min/dropzone.min.css');
require('file-loader?name=[name].[ext]!magnific-popup/dist/magnific-popup.css');
require('file-loader?name=[name].[ext]!alertify.js/dist/css/alertify.css');
require('file-loader?name=[name].[ext]!mprogress/mprogress.min.css');
require('file-loader?name=[name].[ext]!jquery-datetimepicker/jquery.datetimepicker.css');
require('file-loader?name=[name].[ext]!codemirror/lib/codemirror.css');
require('file-loader?name=[name].[ext]!mergely/lib/mergely.css');

// Fonts
require('file-loader?name=fonts/[name].[ext]!font-awesome/css/font-awesome.min.css');
require('file-loader?name=fonts/[name].[ext]!font-awesome/fonts/fontawesome-webfont.eot');
require('file-loader?name=fonts/[name].[ext]!font-awesome/fonts/fontawesome-webfont.svg');
require('file-loader?name=fonts/[name].[ext]!font-awesome/fonts/fontawesome-webfont.ttf');
require('file-loader?name=fonts/[name].[ext]!font-awesome/fonts/fontawesome-webfont.woff');
require('file-loader?name=fonts/[name].[ext]!font-awesome/fonts/fontawesome-webfont.woff2');

// JS
require('file-loader?name=[name].[ext]!mprogress/mprogress.min.js');
require('file-loader?name=[name].[ext]!bowser/bowser.min.js');
require('file-loader?name=[name].[ext]!html5shiv/dist/html5shiv.min.js');
require('file-loader?name=[name].[ext]!bootstrap/dist/js/bootstrap.min.js');
require('file-loader?name=[name].[ext]!moment/min/moment-with-locales.min.js');
require('file-loader?name=[name].[ext]!jquery/dist/jquery.js');
require('file-loader?name=[name].[ext]!underscore/underscore-min.js');
require('file-loader?name=[name].[ext]!bootstrap-material-design/dist/js/material.js');
require('file-loader?name=[name].[ext]!bootstrap-material-design/dist/js/ripples.js');
require('file-loader?name=[name].[ext]!jquery-datetimepicker/jquery.datetimepicker.js');
require('file-loader?name=[name].[ext]!codemirror/lib/codemirror.js');
require('file-loader?name=[name].[ext]!mergely/lib/mergely.js');



// WEBPACK FOOTER //
// ./balus/ui/view/static.js